const toggleEllipsis = document.querySelector('toggle-ellipsis');
const toggleButtonClose = document.querySelector('.toggle-ellipsis__actions[data-actions="close"] button');
if( toggleButtonClose && toggleEllipsis ){
  
  toggleButtonClose.addEventListener('click', function(event) {
    event.preventDefault();
    
    toggleEllipsis.setAttribute('style', '');
    toggleEllipsis.classList.remove('is-open');
  });
}
function checkCollectionSidebarOverflow() {
  
  const filterGroup = document.querySelectorAll('.filter-group details .filter-group__heading');
  
  if( !filterGroup) return;
  
  filterGroup.forEach(itemFilterGroup => {
    
    itemFilterGroup.addEventListener('click', function(event) {
      setTimeout(() => {
        const collectionSidebarForm = document.querySelector('.collection__filters');
        const collectionSidebarContainer = document.querySelector('.collection__sidebar');
        const collectionSidebarButtons = document.querySelector('.collection__sidebar__buttons');
        
        if( collectionSidebarForm && collectionSidebarContainer && collectionSidebarButtons){
          
          if (collectionSidebarForm.scrollHeight > collectionSidebarContainer.clientHeight) {
            collectionSidebarButtons.classList.add('has-overflow');
          } else {
            collectionSidebarButtons.classList.remove('has-overflow');
          }
        };
      }, 400);
    });
  });
}
document.addEventListener('DOMContentLoaded', function() {
  if( document.getElementById('ShopifyChat') ){
    
    document.querySelector('body').classList.add('show-chat');
  }
  checkCollectionSidebarOverflow();
  
  initReadMoreContainers();

  checkFilters(); 
});

if( document.getElementById('deleteAccount') || document.getElementById('deleteAccountMobile') ){
  document.getElementById('deleteAccount').addEventListener('click', function(event) {
    event.preventDefault();
    document.querySelector('.delete-account__modal').classList.add('is-open');
    document.querySelector('.delete-account__modal').setAttribute('aria-hidden', 'false');
  });
  document.getElementById('deleteAccountMobile').addEventListener('click', function(event) {
    event.preventDefault();
    document.querySelector('.delete-account__modal').classList.add('is-open');
    document.querySelector('.delete-account__modal').setAttribute('aria-hidden', 'false');
  });
  document.querySelector('.delete-account__modal .modal__close').addEventListener('click', function(event) {
    event.preventDefault();
    document.querySelector('.delete-account__modal').classList.remove('is-open');
    document.querySelector('.delete-account__modal').setAttribute('aria-hidden', 'true');
  });
  document.querySelector('.modal__overlay').addEventListener('click', function(event) {
    console.log('click');
    event.preventDefault();
    document.querySelector('.delete-account__modal').classList.remove('is-open');
    document.querySelector('.delete-account__modal').setAttribute('aria-hidden', 'true');
  });
  document.querySelector('.delete-account__modal .modal__confirm').addEventListener('click', function(event) {
    event.preventDefault();
    document.querySelector('.delete-account__modal').classList.remove('is-open');
    document.querySelector('.delete-account__modal').setAttribute('aria-hidden', 'true');
    window.location.href = "/account/logout"
  });
}

// Integración del pixel de icomm para tracking de añadir al carrito
document.addEventListener('theme:product:add', function(event) {
  //   addToCartIcomm(event);
});

function addToCartIcomm(item) {
  window._imMktOptions = {
    _setType: 'Lead',
    _setDomain: 'www.emailmarketing.diezxdiez.es',
    _itemsQuantity: item.quantity,
    _amount: (item.final_line_price / 100).toFixed(2),
    _extraInfo: `product_id: ${item.id}, variant_id: ${item.variant_id}`
  };
  
  (function() {
    var icomMkt = document.createElement('script');
    icomMkt.type = 'text/javascript';
    icomMkt.async = true;
    icomMkt.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'externalassets.icommarketing.com/icomMkt_tracking_jquery.min.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(icomMkt, s);
  })();
}

window.addEventListener("planet:smart-cart:add", (event) => {
  const { items } = event.detail;
  const item = items[0];
  addToCartIcomm(item);
});

window.addEventListener('planet:smart-cart:change', (event) => {
  const cart = event.detail;
  const item = cart.items[0];
  addToCartIcomm(item);
}); 

function initReadMoreContainers() {
  document.querySelectorAll('.wim-read-more__container').forEach(container => {
    const content = container.querySelector('.wim-read-more__content');
    const button = container.querySelector('.wim-read-more__btn');
    
    if (!content || !button) return;
    
    const spanReadMore = button.querySelector('.wim-read-more__text');
    const spanReadLess = button.querySelector('.wim-read-less__text');
    
    if (!spanReadMore || !spanReadLess) return;
    
    const maxVisibleLines = parseInt(content.dataset.chunkLines, 10) || 10;
    
    const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
    
    const maxHeight = maxVisibleLines * lineHeight;
    
    const contentHeight = content.scrollHeight;
    
    let visibleMarginBottom = 0;
    let accumulatedHeight = 0;
    
    content.childNodes.forEach(child => {
      if (child.nodeType === 1) { 
        const childHeight = child.offsetHeight;
        const childMarginBottom = parseFloat(getComputedStyle(child).marginBottom) || 0;
        
        accumulatedHeight += childHeight;
        
        if (accumulatedHeight <= maxHeight) {
          visibleMarginBottom += childMarginBottom;
        }
      }
    });
    
    const adjustedMaxHeight = maxHeight + visibleMarginBottom;
    
    const totalLines = Math.ceil(contentHeight / lineHeight);
    
    if (totalLines > maxVisibleLines) {
      button.style.display = 'inline-block';
      
      button.addEventListener('click', function () {
        const isExpanded = content.classList.toggle('expanded');
        
        if (isExpanded) {
          content.style.maxHeight = `${contentHeight}px`;
          spanReadMore.style.display = 'none';
          spanReadLess.style.display = 'inline';
          content.setAttribute('data-expanded', 'true');
          button.setAttribute('aria-expanded', 'true');
        } else {
          content.style.maxHeight = `${adjustedMaxHeight}px`;
          spanReadMore.style.display = 'inline';
          spanReadLess.style.display = 'none';
          content.setAttribute('data-expanded', 'false');
          button.setAttribute('aria-expanded', 'false');
          window.scrollTo({ top: content.getBoundingClientRect().top + window.pageYOffset - adjustedMaxHeight, behavior: 'smooth' });
        }
      });
      
      content.style.maxHeight = `${adjustedMaxHeight}px`;
    } else {
      button.style.display = 'none';
      content.setAttribute('data-expanded', 'true');
    }
  });
}

function checkFilters() {
    const form = document.querySelector('[data-collection-filters-form]');
    const availableCheckbox = document.querySelector('input[name="filter.v.availability"][value="1"]');
    const soldOutCheckbox = document.querySelector('input[name="filter.v.availability"][value="0"]');

    if (form && availableCheckbox) {
        form.addEventListener('change', function(event) {
            // If change come from availability filter "Agotado", dont do anything
            if (event.target === soldOutCheckbox) return;

            // If any other filter checked, enable availability filter
            if (!availableCheckbox.checked) {
                availableCheckbox.checked = true;

                // Trigger event to update collection
                availableCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }
}

// Feedback Marc 19-oct: con la cabecera transparente, las entradas con desplegable simple (Baño, Playa, Cocina) no ponían el fondo blanco al pasar el ratón
(function () {
  var header = document.querySelector('[data-header-transparent]');
  if (!header) return;
  var items = header.querySelectorAll('.header__desktop .menu__item.parent');
  var solid = function () { header.classList.add('meganav--visible'); };
  var clear = function () {
    setTimeout(function () {
      if (!header.querySelector('.header__desktop .menu__item:hover, .header__desktop .menu__item:focus-within')) {
        header.classList.remove('meganav--visible');
      }
    }, 60);
  };
  items.forEach(function (item) {
    item.addEventListener('mouseenter', solid);
    item.addEventListener('focusin', solid);
    item.addEventListener('mouseleave', clear);
    item.addEventListener('focusout', clear);
  });
})();

/* Menú móvil diferido: la página trae solo el primer nivel y el menú completo se pide después de cargar o al tocar el botón del menú */
(function () {
  var holder = document.querySelector('[data-wim-lazy-menu]');
  if (!holder) return;
  var state = 'idle';

  function load() {
    if (state !== 'idle') return;
    state = 'loading';
    fetch(holder.getAttribute('data-wim-lazy-menu') + '?section_id=wim-mobile-menu-links', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var start = html.indexOf('>') + 1;
        var end = html.lastIndexOf('</div>');
        var inner = html.slice(start, end).trim();
        if (!inner) throw new Error('empty');
        holder.innerHTML = inner;
        holder.removeAttribute('data-wim-lazy-menu');
        state = 'done';
      })
      .catch(function () {
        state = 'idle';
      });
  }

  ['pointerdown', 'touchstart', 'focusin', 'mouseenter'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      if (event.target.closest && event.target.closest('[data-drawer-toggle]')) load();
    }, { passive: true, capture: true });
  });

  window.addEventListener('load', function () {
    var trigger = document.querySelector('.header__mobile__hamburger');
    if (!trigger || !trigger.offsetParent) return;
    var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1500); };
    idle(load, { timeout: 4000 });
  });
})();
